import styled from 'styled-components';
import tw from 'twin.macro';

export default styled.div.attrs(() => ({
  'data-test-container': 'backdrop'
}))(() => [
  tw`fixed inset-0 bg-black bg-opacity-50`,
  'touch-action: none;',
  'z-index: -1;'
]);
